import React from "react";

const Chapter8 = () => {
  return (
    <>
      <h2>
        Does storm runoff from urban areas influence the amount of{" "}
        <em>E. coli</em> in our lakes and rivers?
      </h2>
      <p>
        <em>E. coli</em> is often present in storm runoff from urban areas.
      </p>

      <p>
        When heavy rain falls or snow melts, that water moves over and through
        the ground taking with it natural and human-made pollutants. In urban
        areas, this water cannot soak into the ground so it flows over
        impervious surfaces like streets and moves quickly into nearby lakes or
        rivers. Urban storm runoff can mobilize contaminants like fecal matter
        (a source of <em>E. coli</em>) that have accumulated on urban
        landscapes, transporting those contaminants into nearby waters.
      </p>

      <p>
        Water coming out of storm drains may contain bacteria or other
        pollutants that can make you sick, so it is best to avoid contact with
        water near flowing storm drains.
      </p>
    </>
  );
};

export default Chapter8;
